module.exports = __webpack_public_path__ + "static/media/Assets-09-Capital-hero.f3f547c2.jpg";